var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 3L23 29C23 29 21 31 16 31C11 31 9 29 9 29L5 3",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3C5 3.53043 6.15893 4.03914 8.22183 4.41421C10.2847 4.78929 13.0826 5 16 5C18.9174 5 21.7153 4.78929 23.7782 4.41421C25.8411 4.03914 27 3.53043 27 3C27 2.46957 25.8411 1.96086 23.7782 1.58579C21.7153 1.21071 18.9174 1 16 1C13.0826 1 10.2847 1.21071 8.22183 1.58579C6.15893 1.96086 5 2.46957 5 3V3Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84668 15C6.84668 15.2626 7.08344 15.5227 7.54344 15.7654C8.00343 16.008 8.67766 16.2285 9.52763 16.4142C10.3776 16.5999 11.3866 16.7472 12.4972 16.8478C13.6077 16.9483 14.798 17 16 17C17.202 17 18.3923 16.9483 19.5028 16.8478C20.6134 16.7472 21.6224 16.5999 22.4724 16.4142C23.3224 16.2285 23.9966 16.008 24.4566 15.7654C24.9166 15.5227 25.1533 15.2626 25.1533 15C25.1533 14.7374 24.9166 14.4773 24.4566 14.2346C23.9966 13.992 23.3224 13.7715 22.4724 13.5858C21.6224 13.4001 20.6134 13.2528 19.5028 13.1522C18.3923 13.0517 17.202 13 16 13C14.798 13 13.6077 13.0517 12.4972 13.1522C11.3866 13.2528 10.3776 13.4001 9.52763 13.5858C8.67766 13.7715 8.00343 13.992 7.54344 14.2346C7.08344 14.4773 6.84668 14.7374 6.84668 15V15Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterGlass);
export default __webpack_public_path__ + "static/media/WaterGlass.f68f1f11a368a71cd4a98a522ccc5421.svg";
export { ForwardRef as ReactComponent };